import { render, staticRenderFns } from "./Harjoitukset.vue?vue&type=template&id=0746a534&scoped=true"
import script from "./Harjoitukset.vue?vue&type=script&lang=js"
export * from "./Harjoitukset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0746a534",
  null
  
)

export default component.exports